import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";

import { registerConfirmCodeDialog } from "../util/confirmCode";

// Asks for the admin's authenticator code when the server requires
// confirmation for a sensitive action. Mounted once in App. The dialog calls
// it a "PIN" on purpose; the value is the current authenticator code.
const ConfirmCodeDialog = () => {
  const [request, setRequest] = useState(null);
  const [value, setValue] = useState("");
  const resolver = useRef(null);

  useEffect(
    () =>
      registerConfirmCodeDialog(
        (message) =>
          new Promise((resolve) => {
            // A newer request supersedes one still open.
            if (resolver.current) resolver.current(null);
            resolver.current = resolve;
            setValue("");
            setRequest({ message });
          })
      ),
    []
  );

  const finish = (result) => {
    const resolve = resolver.current;
    resolver.current = null;
    setRequest(null);
    setValue("");
    if (resolve) resolve(result);
  };

  const submit = (event) => {
    event.preventDefault();
    const entered = value.trim();
    if (!entered) return;
    finish({ code: entered.replace(/\s/g, "") });
  };

  return (
    <Dialog
      open={Boolean(request)}
      onClose={() => finish(null)}
      fullWidth
      maxWidth="xs"
      style={{ zIndex: 2000 }}
    >
      {/* The dialog paper is dark (custom.css), so text needs explicit light colors.
          The title is a span, not a heading: main.css forces h1-h6 to gray with !important. */}
      <DialogTitle disableTypography>
        <span style={{ color: "#fff", fontSize: "1.25rem", fontWeight: 500 }}>Confirm action</span>
      </DialogTitle>
      <DialogContent style={{ color: "#e4e6eb" }}>
        <form onSubmit={submit} autoComplete="off">
          {request?.message && <p className="mb-3">{request.message}</p>}
          <label className="form-label" htmlFor="confirm-code" style={{ color: "#fff" }}>
            PIN
          </label>
          <input
            id="confirm-code"
            className="form-control mb-3"
            autoFocus
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={7}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <div className="d-flex justify-content-end gap-2 mb-2">
            <button type="button" className="btn btn-outline-secondary" onClick={() => finish(null)}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger">
              Confirm
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmCodeDialog;
